import React, { useEffect } from "react";
import {
  Edit,
  SimpleForm,
  useDataProvider,
  useEditController,
  useNotify,
  useRefresh,
} from "react-admin";
import { transformDateForInputValue } from "../../helpers/dateHelper";
import { RightsRow, StaffUser, StaffUserRole } from "../../types/staffUser";
import DocumentTitle from "../common/documentTitle/DocumentTitle";
import CreateNewStaffUserFormBody from "./ScreateNewStaffUserFormBody";
import SimpleFormToolbar from "./SimpleFormToolbar";

const StaffUserEdit = (props) => {
  const controllerProps = useEditController<StaffUser>(props);
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const refresh = useRefresh();
  const [isUserBlocked, setDoesUserBlocked] = React.useState<any>(
    controllerProps.record?.isBlocked
  );
  const [rights, setRights] = React.useState<any>();
  const handleUserStatus = () => {
    setDoesUserBlocked(!isUserBlocked);
  };

  const handleChangeUserRights = (rights) => {
    setRights(rights);
  };

  useEffect(() => {
    if (controllerProps.record) {
      setRights(controllerProps.record?.permissions);
    }
  }, [controllerProps.record]);

  const onSuccess = (
    userRights: Array<RightsRow>,
    isUserBlocked: boolean,
    userId: string
  ) => async (data) => {
    const staffUserData: StaffUser = {
      email: data.email,
      name: data.name || "",
      surname: data.surname || "",
      isBlocked: isUserBlocked,
      permissions: userRights,
      role: data.role,
      skype: data.skype,
      startDate: data.createDate,
      id: userId,
    };
    try {
      const result = await dataProvider.update("staff", {
        id: userId,
        data: staffUserData,
        previousData: {} as StaffUser,
      });
      if (!result.data) {
        notify("something went wrong", "error");
      }
      notify(`User updated`);
      refresh();
    } catch (error) {
      notify("Email is already taken", "error");
    }
  };

  return (
    <>
      <DocumentTitle
        core="Staff"
        purpose={`${controllerProps.record?.name}`}
        appointment={`${controllerProps.record?.surname}`}
      />
      <Edit {...props} className="user-toolbar">
        {rights && controllerProps.record && (
          <SimpleForm
            toolbar={
              <SimpleFormToolbar
                {...props}
                onSuccess={onSuccess(
                  rights,
                  isUserBlocked,
                  controllerProps.record.id
                )}
              />
            }
            className="general-tab"
          >
            <CreateNewStaffUserFormBody
              staffUserRights={rights}
              setRights={handleChangeUserRights}
              creationDate={transformDateForInputValue(
                controllerProps.record?.startDate
              )}
              userRole={controllerProps.record?.role}
              isUserBlocked={isUserBlocked}
              handleChangeUserStatus={handleUserStatus}
            />
          </SimpleForm>
        )}
      </Edit>
    </>
  );
};

export default StaffUserEdit;
